import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

// Images
import {Card, Divider, InputLabel} from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import viewEvaluation from "../../assets/Performance_Evalution_flow.pdf";
import properties from "constants/ApplicationConstants";
import {useNavigate} from "react-router-dom";

function Appraisal_Form() {
    const storedEmpId = localStorage.getItem("empId") || sessionStorage.getItem("empId");
  const navigate = useNavigate();

  const handlecurrentEval = () => {
    navigate("/appraisal");
  };
  const handlePreviousDataClick = () => {
    navigate("/viewrating");
  };
  const handleAssignedGoals=()=>{
    navigate(`/manager/appraisal/goal-settings/${storedEmpId}`);
  }
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card>
        <MDBox pt={4} pb={3} px={3}>
          <InputLabel
            sx={{fontWeight: "bold", fontFamily: properties.fontFamily}}
            id="Appraisal_Form"
            mb={2}
          >
            Performance Evaluation
          </InputLabel>
        </MDBox>
        <Divider />

        <MDBox mt={2} mb={4} gap={1.5}>
          <MDBox
            component="ul"
            sx={({breakpoints}) => ({
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "center",
              listStyle: "none",
              mt: 3,
              mb: 0,
              p: 0,
              gap: 2,
              [breakpoints.up("lg")]: {
                mt: 0
              }
            })}
          >
            <MDButton variant="outlined" color="info" sx={4} href={viewEvaluation} target="_blank">
              View Evaluation Flow
            </MDButton>
            <MDButton
              variant="gradient"
              color="info"
              sx={{background: properties.colors.bgcolorbluethem}}
              href=""
              target="_blank"
              onClick={handlecurrentEval}
            >
              Current Year Evaluation Form
            </MDButton>
            <MDButton
              variant="gradient"
              color="info"
              sx={{background: properties.colors.bgcolorbluethem}}
              href=""
              target="_blank"
              onClick={handlePreviousDataClick}
            >
              Previous Data
            </MDButton>
            {/* <MDButton
              variant="gradient"
              color="info"
              sx={{background: properties.colors.bgcolorbluethem}}
              href=""
              target="_blank"
              onClick={handleAssignedGoals}
            >
              Assigned Goals
            </MDButton> */}
          </MDBox>
        </MDBox>
      </Card>
    </DashboardLayout>
  );
}

export default Appraisal_Form;
